import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
import { FieldRow, SegmentedControl } from '@/core/ui';
import { unitsAtom } from './unitsAtom';
import { UNIT_SYSTEMS, type UnitSystem } from './unitSystems';

const OPTIONS = (['metric', 'imperial'] as const).map((value: UnitSystem) => ({
  value,
  label: UNIT_SYSTEMS[value].height.symbol,
}));

export function UnitsField() {
  const { t } = useTranslation('units');
  const [units, setUnits] = useAtom(unitsAtom);
  return (
    <FieldRow group label={t('label')}>
      <SegmentedControl
        compact
        className="min-w-[84px]"
        options={OPTIONS}
        value={units}
        onChange={setUnits}
      />
    </FieldRow>
  );
}
